// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const NotificationOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="NotificationOffIcon" ref={forwardedRef} {...props}>
      <path d="M9 4.111V2.5h1.996v1.613a4.5 4.5 0 0 1 2.642 1.75l1.883-1.884 1.06 1.06-12.02 12.022L3.5 16 5 14.5H4v-1.498h.015l1.482-.498V8.498A4.5 4.5 0 0 1 9 4.11M7 12.5l5.556-5.556a2.997 2.997 0 0 0-5.56 1.554v3.009H7z" />
      <path d="m12.996 10.747 1.496-1.496.008 3.253 1.486.498H16V14.5H9.242l1.501-1.5H13v-1.5h-.002z" />
      <path d="M9 18v-2h1.996v2z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const NotificationOffIcon = /* @__PURE__ */ Object.assign(
  NotificationOffIconComponent,
  { displayName: 'NotificationOffIcon' },
);
